// 2026년 AI·디지털 리터러시 진단검사 결과지.
// 2025년 결과지(ai-literacy-result.js)는 그대로 두고, 2026 버전은 별도 디렉터리/라우트로 분리한다.
import ResultAiIndex from '@/views/result/ai-literacy-2026/index.vue';
import ResultAiStudent from '@/views/result/ai-literacy-2026/student/index.vue';
import ResultAiTeacher from '@/views/result/ai-literacy-2026/teacher/index.vue';
import ResultAiPrincipal from '@/views/result/ai-literacy-2026/principal/index.vue';
import ResultAiParent from '@/views/result/ai-literacy-2026/parent/index.vue';
import ResultStatusAI from '@/views/result/ai-literacy-2026/teacher/StatusAI.vue';
import ResultAiSchoolStatus from '@/views/result/ai-literacy-2026/principal/SchoolStatusAI.vue';

const routes = [
  {
    path: "/result/ai-literacy-2026",
    component: ResultAiIndex,
    children: [
      {
        path: "student",
        name: "ResultAiStudent2026",
        component: ResultAiStudent,
      },
      {
        path: "teacher",
        name: "ResultAiTeacher2026",
        component: ResultAiTeacher,
      },
      {
        path: "principal",
        name: "ResultAiPrincipal2026",
        component: ResultAiPrincipal,
      },
      {
        path: "parent",
        name: "ResultAiParent2026",
        component: ResultAiParent,
      },
      {
        path: "status",
        name: "ResultStatusAI2026",
        component: ResultStatusAI,
      },
      {
        path: "school-status",
        name: "ResultAiSchoolStatus2026",
        component: ResultAiSchoolStatus,
      }
    ]
  },
];

export default routes;
